export default __webpack_public_path__ + "static/media/blog1.3bbf41ea.jpg";